import { render, staticRenderFns } from "./AdminUserDetail.vue?vue&type=template&id=37cdeb9e&"
import script from "./AdminUserDetail.vue?vue&type=script&lang=js&"
export * from "./AdminUserDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports